import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { formatWeekRange, shiftDate } from "@/lib/format";

type WeekPickerProps = {
  week: string;
  currentWeek: string;
  onChange: (week: string) => void;
};

/** Previous / next week with the range in between; the future is not shown. */
export function WeekPicker({ week, currentWeek, onChange }: WeekPickerProps) {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? "ru";
  return (
    <div className="flex items-center gap-1">
      <Button
        variant="secondary"
        size="icon"
        aria-label={t("timesheets.prevWeek")}
        onClick={() => onChange(shiftDate(week, -7))}
      >
        <ChevronLeft />
      </Button>
      <span className="min-w-36 px-2 text-center font-medium tabular-nums" aria-live="polite">
        {formatWeekRange(week, lang)}
      </span>
      <Button
        variant="secondary"
        size="icon"
        aria-label={t("timesheets.nextWeek")}
        disabled={week >= currentWeek}
        onClick={() => onChange(shiftDate(week, 7))}
      >
        <ChevronRight />
      </Button>
      {week !== currentWeek && (
        <Button variant="ghost" size="sm" onClick={() => onChange(currentWeek)}>
          {t("timesheets.thisWeek")}
        </Button>
      )}
    </div>
  );
}
